import { useState, useMemo } from "react";

// Función para convertir fechas en formato "MM/DD/YYYY HH:mm AM/PM" a objeto Date
const parseDate = (dateString) => {
  if (!dateString) return new Date(0);
  const [date, time, period] = dateString.split(" ");
  if (!date || !time || !period) return new Date(0);
  const [month, day, year] = date.split("/");
  let [hour, minute] = time.split(":");
  if (!month || !day || !year || !hour || !minute) return new Date(0);
  if (period === "PM" && hour !== "12") {
    hour = (parseInt(hour, 10) + 12).toString();
  } else if (period === "AM" && hour === "12") {
    hour = "00";
  }
  return new Date(`${year}-${month}-${day}T${hour}:${minute}:00`);
};

export const useSortableData = (items = [], config = null) => {
  const [sortConfig, setSortConfig] = useState(config);

  const sortedItems = useMemo(() => {
    let sortableItems = [...(items || [])];
    if (sortConfig !== null && sortableItems.length > 0) {
      sortableItems.sort((a, b) => {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        if (sortConfig.type === "date") {
          aValue = parseDate(aValue);
          bValue = parseDate(bValue);
          return sortConfig.direction === "asc"
            ? aValue - bValue
            : bValue - aValue;
        } else if (sortConfig.type === "number") {
          // Para números puros
          aValue = Number(aValue);
          bValue = Number(bValue);
          return sortConfig.direction === "asc"
            ? aValue - bValue
            : bValue - aValue;
        } else if (sortConfig.type === "phone") {
          // Para números que incluyen el signo +
          aValue = (a[sortConfig.key] || []).map((p) => p.telefono).join(",");
          bValue = (b[sortConfig.key] || []).map((p) => p.telefono).join(",");
          aValue = aValue.replace(/\+/g, ""); // Quita el "+" para comparación numérica
          bValue = bValue.replace(/\+/g, "");
          return sortConfig.direction === "asc"
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        } else {
          // Para textos: forzamos a cadena minúscula
          aValue = (aValue || "").toString().toLowerCase();
          bValue = (bValue || "").toString().toLowerCase();
          return sortConfig.direction === "asc"
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        }
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key, type = "text") => {
    let direction = "asc";
    if (sortConfig && sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction, type });
  };

  return { items: sortedItems, requestSort, sortConfig };
};
